import { useEffect, useRef, useState } from "react";
import { fetchConnectedSources } from "../../ApiHandlerGlobal";

export type ConnectedSourcesStatus = "loading" | "ready" | "error";

export const useConnectedSources = (
  sourceIdToName: Record<number, string>,
  persistConnectionFlags = false
) => {
  const [connectedSources, setConnectedSources] = useState<string[]>([]);
  const [status, setStatus] = useState<ConnectedSourcesStatus>("loading");
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (hasFetchedRef.current) {
      return;
    }
    hasFetchedRef.current = true;

    const loadConnectedSources = async () => {
      const data = await fetchConnectedSources(
        localStorage.getItem("tenant_id"),
        localStorage.getItem("api_key")
      );

      if (data?.status) {
        const connectedNames = data.source_ids
          .map(id => sourceIdToName[id])
          .filter((name): name is string => Boolean(name));

        setConnectedSources(connectedNames);
        if (persistConnectionFlags) {
          Object.values(sourceIdToName).forEach(sourceName => {
            localStorage.setItem(`${sourceName}_connected`, String(connectedNames.includes(sourceName)));
          });
        }
        setStatus("ready");
        return;
      }
      setStatus("error");
    };

    loadConnectedSources();
  }, [persistConnectionFlags, sourceIdToName]);

  return { connectedSources, setConnectedSources, status };
};
